import React, { FC, useEffect } from 'react'
import { MainCTAWrapper } from './style'

//* Helpers
import formatInlineCode from '../../../utils/shortTextFormatting'

//* Components
import { LocaleCodes } from '../../../constants/localization.constants'
import { ComponentMainCTA } from '../../../models/components/mainCta'
import { cnPrivacyPolicy, cnWebinarTerms, renderMarketoOrIframe } from '../../../utils/cn.utils'
import Marketo from '../../global/marketo'
import Typography from '../typography'
import { MainCtaButtons } from './subcomponents'

type Props = {
  data: ComponentMainCTA
  locale?: string
}

const MainCTA: FC<Props> = ({ data, locale }) => {
  if (!data) return null

  const mainCtaData = {
    title: data.title || '',
    subtitle: data.subtitle || '',
    cta: data.ctAs || [],
    disclaimer: data.disclaimer || '',
    marketoForm: data.marketoForm?.marketoForm || null,
    cnFormOverride: data.cnFormOverride || null,
  }

  const isForm = !!mainCtaData.marketoForm
  const cnLocale = LocaleCodes.CHINESE.code

  /* Privacy and Webinar terms redirect function for Iframe CN override Form */
  if (locale === cnLocale) {
    useEffect(() => {
      if (typeof window === 'undefined') return

      const url = window.location.href
      const match =
        url.includes('/events/agentic-automation-summit/beijing') ||
        url.includes('/showcase/beijing-agentic-automation-executive-dinner') ||
        url.includes('/events/agentic-automation-summit/shanghai') ||
        url.includes('/showcase/shanghai-agentic-automation-executive-dinner')

      if (match) {
        window.goThankYouEvent = () => {
          window.open(
            'https://www.uipath.com.cn/g/thank-you-event-agentic-automation-summit',
            '_self',
            'noopener'
          )
        }
      }
    }, [])

    cnPrivacyPolicy()
    cnWebinarTerms()
  }

  return (
    <MainCTAWrapper $isForm={isForm} data-cy="mainCTA">
      <div className="MainCTA__Inner">
        {mainCtaData.title && (
          <Typography className="MainCTA__Title" type="header2">
            {formatInlineCode(mainCtaData.title)}
          </Typography>
        )}

        {mainCtaData.subtitle && (
          <Typography className="MainCTA__Subtitle" type="leadXS">
            {formatInlineCode(mainCtaData.subtitle)}
          </Typography>
        )}

        {isForm && locale !== cnLocale ? (
          <Marketo data-cy="mainCTA-MKO-Form" formData={mainCtaData.marketoForm} />
        ) : (
          <>
            {mainCtaData.cnFormOverride &&
              renderMarketoOrIframe({
                defaultLocale: locale,
                marketoFormData: mainCtaData.marketoForm,
                cnFormOverride: mainCtaData.cnFormOverride,
              })}
          </>
        )}

        <MainCtaButtons mainCtaData={mainCtaData} />

        {mainCtaData.disclaimer && (
          <p className="MainCTA__Disclaimer">{formatInlineCode(mainCtaData.disclaimer)}</p>
        )}
      </div>
    </MainCTAWrapper>
  )
}

export default MainCTA
